export default  {"src":"/_next/static/image/img/cerahKids/12-17.5b14c3bee61cd17c661a98e64d6e7e5c.svg","height":512,"width":512};